
export const REQUEST_DELETE_CURRENT_JOB_ACTION = 'REQUEST_DELETE_CURRENT_JOB_ACTION'
export const RECEIVE_DELETE_CURRENT_JOB_SUCCESS = 'RECEIVE_DELETE_CURRENT_JOB_SUCCESS'
export const RECEIVE_DELETE_CURRENT_JOB_FAILURE = 'RECEIVE_DELETE_CURRENT_JOB_FAILURE'

const initialState = {
  isFetching: false,
  errors: [],
  newData: false,
  currentJob: {
    id: '',
    client_id: '',
    latitude: 0,
    longitude: 0,
    addressline1: '',
    addressline2: '',
    city: '',
    state: '',
    zip: '',
    place_id: '',
    country: '',
    notes: '',
    first_name: '',
    last_name: '',
    email: '',
    pretty_primary_phone: '',
    secondary_first_name: '',
    secondary_last_name: '',
    secondary_email: '',
    pretty_secondary_phone: '',
    resource_type: {
      id: '',
      name: ''
    },
    resources: [],
    client: {}
  }
}
const currentJobReducer = (reduxState = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case REQUEST_DELETE_CURRENT_JOB_ACTION:
      return {
        ...reduxState,
        isFetching: true,
        errors: []
      }
    case RECEIVE_DELETE_CURRENT_JOB_SUCCESS:
      return {
        ...reduxState,
        isFetching: false,
        errors: []
      }
    case RECEIVE_DELETE_CURRENT_JOB_FAILURE:
      return {
        ...reduxState,
        isFetching: false,
        errors: payload.errors
      }

    default:
      return reduxState
  }
}

export default currentJobReducer
